module.exports = __webpack_public_path__ + "img/logo2.0c57d00f.png";